/* ============
 * City Module Mutations
 * ============
 */

import {
  FETCH_TAXES,
} from './../../mutation-types';

export default {
  [FETCH_TAXES](state, { taxes }) {
    state.all = taxes;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/tax/mutations.js